var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0161 15.912H10.9201V17.608H9.08011V15.912H7.91211V14.472H9.08011V13.192H7.91211V11.592H9.08011V6.392H12.1041C12.9148 6.392 13.5761 6.49866 14.0881 6.712C14.6108 6.92533 15.0214 7.20267 15.3201 7.544C15.6188 7.87466 15.8214 8.24266 15.9281 8.648C16.0348 9.05333 16.0881 9.45333 16.0881 9.848C16.0881 10.232 16.0241 10.6267 15.8961 11.032C15.7788 11.4267 15.5654 11.7893 15.2561 12.12C14.9468 12.44 14.5308 12.7067 14.0081 12.92C13.4961 13.1227 12.8454 13.224 12.0561 13.224H10.9201V14.472H13.0161V15.912ZM10.9201 11.592H12.0881C12.3121 11.592 12.5468 11.5707 12.7921 11.528C13.0481 11.4747 13.2828 11.384 13.4961 11.256C13.7201 11.128 13.9014 10.952 14.0401 10.728C14.1788 10.4933 14.2481 10.1947 14.2481 9.832C14.2481 9.45866 14.1841 9.15466 14.0561 8.92C13.9388 8.68533 13.7788 8.504 13.5761 8.376C13.3734 8.23733 13.1441 8.14666 12.8881 8.104C12.6428 8.05066 12.3868 8.024 12.1201 8.024H10.9201V11.592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.dec2ca7537244a117c636f66b0ee44ee.svg";
export { ForwardRef as ReactComponent };